// extracted by mini-css-extract-plugin
export default {"container":"ManageTournamentContent_container__MsDiS","loading":"ManageTournamentContent_loading__jCrus"};